<template>
    <p class="row-sezione">
        <i class="fa fa-check fa-3x color"></i><br><br>
        <b>
            <span v-if="this.confirmed">
                {{$t('prenotazione_tavolo.richiesta_confermata')}}<br>
                {{$t('prenotazione_tavolo.ti_aspettiamo')}}<br>
            </span>
            <span v-else>
                {{$t('prenotazione_tavolo.richiesta_inviata')}}<br>
                {{$t('prenotazione_tavolo.attendi_conferma')}}<br>
            </span>
            {{$t('prenotazione_tavolo.augurio')}}
        </b>
        <br><br>
        <router-link :to="{name:'home'}">
            <button class="btn btn-primary mx-auto" style="width:230px;">
                {{$t('prenotazione_tavolo.torna_home')}}
            </button>
        </router-link>
    </p>
</template>

<script>
export default {
    name: "ReserveConfirmation",
    props: ['confirmed']
}
</script>
